/* eslint-disable no-shadow */
export enum VehicleDetailImagesType {
	frontLightsPhoto = 'frontLightsPhoto',
	exhaustPhoto = 'exhaustPhoto',
	frontWheelPhoto = 'frontWheelPhoto',
	dashboardPhoto = 'dashboardPhoto',
	trunkOrSeatOpenPhoto = 'trunkOrSeatOpenPhoto',
	rearSuspensionPhoto = 'rearSuspensionPhoto',
	rearLightPhoto = 'rearLightPhoto',
	offRoadPhoto = 'offRoadPhoto',
	urbanEnvironmentPhoto = 'urbanEnvironmentPhoto',
	withDriverPhoto = 'withDriverPhoto',
	realEnvironmentParkedPhoto = 'realEnvironmentParkedPhoto',
	motionDetailPhoto = 'motionDetailPhoto',
	rearWheelPhoto = 'rearWheelPhoto',
}
export const VehicleDetailImagesTypeValues = {
	[VehicleDetailImagesType.frontLightsPhoto]: {
		title: 'Luces delanteras',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.rearLightPhoto]: {
		title: 'Luz trasera',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.exhaustPhoto]: {
		title: 'Escape',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.frontWheelPhoto]: {
		title: 'Llanta delantera',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.rearWheelPhoto]: {
		title: 'Llanta trasera',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.dashboardPhoto]: {
		title: 'Tablero',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.trunkOrSeatOpenPhoto]: {
		title: 'Baúl o asiento abierto',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.rearSuspensionPhoto]: {
		title: 'Suspensión trasera',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.offRoadPhoto]: {
		title: 'Terreno destapado',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.urbanEnvironmentPhoto]: {
		title: 'Entorno urbano',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.withDriverPhoto]: {
		title: 'Conductor',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.realEnvironmentParkedPhoto]: {
		title: 'Estacionado en entorno real',
		accept: 'image/png, image/jpeg',
	},
	[VehicleDetailImagesType.motionDetailPhoto]: {
		title: 'Detalle en movimiento',
		accept: 'image/png, image/jpeg',
	},
};
